<template>
  <div class="base-layout">
    <a-layout class="base-layout__shell">
      <a-layout-sider v-if="!isMobile" class="sidebar" width="256" v-model="collapsed" :trigger="null" collapsible>
        <sidebar :collapsed="collapsed" />
      </a-layout-sider>

      <a-layout v-if="isLogin">
        <a-layout-header class="headbar">
          <headbar :collapsed="collapsed" :username="username" @toggleCollapsed="toggleCollapsed" />
        </a-layout-header>

        <a-layout-content class="base-layout__content">
          <router-view v-if="havePermisssion && isRouterAlive" class="page-view" />
          <a-result v-else status="403" title="403" sub-title="抱歉，您无权访问此页面" style="margin-top: 36px;" />
        </a-layout-content>
      </a-layout>

      <a-drawer
        v-if="isLogin"
        placement="left"
        :closable="false"
        :visible="mobileMenuVisible"
        :width="256"
        :body-style="{ padding: 0 }"
        @close="mobileMenuVisible = false"
      >
        <sidebar :collapsed="false" @navigate="mobileMenuVisible = false" />
      </a-drawer>
    </a-layout>
  </div>
</template>

<script>

export default {
  name: 'BaseLayout',
  components: {
    Headbar: () => import('@/components/Headbar/Headbar'),
    Sidebar: () => import('@/components/Sidebar/Sidebar'),
  },
  provide() {
    return {
      reloadPage: () => {
        return this.reloadPage()
      },
    }
  },
  data() {
    return {
      isLogin: false,
      collapsed: false,
      isRouterAlive: true,
      isMobile: false,
      mobileMenuVisible: false,
    };
  },
  computed: {
    username() {
      return this.$store.state.user.username
    },
    isManager() {
      return this.$store.state.user.isManager
    },
    permissions() {
      return this.$store.state.user.permissions
    },
    havePermisssion() {
      let permission = this.$route.meta.permission;
      return this.isManager || !(this.permissions[permission] && this.permissions.indexOf(permission) == -1);
    },
  },

  methods: {
    initialize() {
      if(this.username==''){
        this.$message.warn('登录失效');
        this.$router.push('/page/user/login');
        return;
      }
      this.isLogin=true;
    },
    toggleCollapsed() {
      if (this.isMobile) {
        this.mobileMenuVisible = !this.mobileMenuVisible;
        return;
      }
      this.collapsed = !this.collapsed;
    },
    reloadPage() {
      this.isRouterAlive = false;
      this.$nextTick(() => this.isRouterAlive = true);
    },
    updateViewport() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) {
        this.mobileMenuVisible = false;
      }
    },
  },
  mounted() {
    this.updateViewport();
    window.addEventListener('resize', this.updateViewport);
    this.initialize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewport);
  },
}
</script>

<style scoped>
.base-layout,
.base-layout__shell {
  min-height: 100%;
}

.headbar {
  background: #fff;
  padding: 0;
  box-shadow: 0px 1px 10px #7774;
  position: sticky;
  top: 0;
  z-index: 9;
}

.sidebar {
  background: #fff;
  overflow: auto;
  box-shadow: 1px 0px 10px #7774;
}

.base-layout__content {
  min-width: 0;
}

.page-view {
  padding: 8px;
}

@media (max-width: 768px) {
  .headbar {
    height: 52px;
    line-height: 52px;
  }

  .page-view {
    padding: 8px;
  }
}
</style>
